import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { publicLayoutRoute } from './public'
import { useGetSiteIdentity } from '@/application/services/settings.service'
import { useDocumentMeta } from '@/application/hooks/useDocumentMeta'
import { OG_IMAGE_URL } from '@/application/seo/site'
import { useLocalizedUrl } from '@/application/hooks/useLocalizedUrl'
import { resolveLanguage } from '@/application/i18n/language'
import { ClassicHomePage } from './public/home/ClassicHomePage'
import { NewsHomePage } from './public/home/NewsHomePage'

export const indexRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: '/',
  component: IndexComponent,
})

/**
 * Switches between the classic and news homepage layouts based on the
 * `homepageLayout` site setting. `useGetSiteIdentity` is already in flight
 * from `PublicJsonLd` on every public page, so this read is cache-warm and
 * the loading window (`homepageLayout` undefined) resolves to the news
 * layout, which is now the default — only an explicit `'classic'` value
 * opts back into the classic layout.
 */
export function IndexComponent() {
  const { t, i18n } = useTranslation()
  const lang = resolveLanguage(i18n.language)
  const { data: siteIdentity } = useGetSiteIdentity(lang)
  const homeUrl = useLocalizedUrl('/')

  useDocumentMeta({
    title: t('seo.home_title'),
    description: t('seo.home_description'),
    imageUrl: OG_IMAGE_URL,
    url: homeUrl,
    type: 'website',
  })

  return siteIdentity?.homepageLayout === 'classic' ? <ClassicHomePage /> : <NewsHomePage />
}
